import React, { useEffect, useState } from "react";
import { Card, Nav, Tab } from "react-bootstrap";
import MainPagetitle from "../../../layouts/MainPagetitle";
import MyEarningCards from "./myEarningCards";
import Pending from "./pending/pending";
import Processed from "./processed/processed";
import PaymentDetails from "./paymentDetails/paymentDetails";
import AllPayouts from "./allPayouts/allPayouts";

const MyEarnings = (props) => {
  const isAdmin = props?.$store?.user?.role === _enum.ROUTE_PERSONAS.admin;
  const isConnector =
    props?.$store?.user?.role === _enum.ROUTE_PERSONAS.connector;
  const isPanVerified = props.$store?.user?.is_pan_code_verified;
  const isAadharVerified = props.$store?.user?.is_aadhar_verified;
  const is_agreement_signed = props.$store?.user?.is_agreement_signed;

  const [activeKey, setActiveKey] = useState("pending");
  const tabData = [
    // {
    //   key: "all",
    //   name: "Pending Applications",
    // },
    {
      key: "pending",
      name: "Pending Applications",
    },
    {
      key: "processed",
      name: "Processed",
    },
    {
      key: "paymentdetails",
      name: "Payment details",
    },
  ];

  const handleSelect = (key) => {
    setActiveKey(key);
  };

  useEffect(() => {
    if (isConnector) {
      if (!isPanVerified || !isAadharVerified || !is_agreement_signed) {
        swal2
          .fire({
            title: "Account Verification Pending",
            text: "Please complete your profile",
            icon: "info",
            iconColor: "#234C9B",
          })
          .then((result) => {
            if (result.isConfirmed) {
              props.navigate("/app/myprofile");
            }
          });
      }
    }
  }, []);

  return (
    <>
      <MainPagetitle
        mainTitle={isAdmin ? "Payout Details" : "My Earnings"}
        pageIcon={imagepaths.WalletIconActive}
      />
      {!isConnector ||
      (isPanVerified && isAadharVerified && is_agreement_signed) ? (
        <div className="container-fluid">
          {/* {isAdmin && (
            <div className="header_box">
              <MyEarningCards />
            </div>
          )} */}
          <Tab.Container>
            <Card name="custom-tab" className="dz-card min-h-[600px]">
              <Tab.Content>
                <Card.Body>
                  {/* <!-- Nav tabs --> */}
                  <div className="custom-tab-1 myearnings">
                    <Tab.Container
                      defaultActiveKey={activeKey}
                      activeKey={activeKey}
                      onSelect={handleSelect}
                    >
                      <Nav as="ul" className="nav-tabs">
                        {!isAdmin
                          ? tabData
                              // .filter((v) => v.key !== "processed")
                              .map((data, i) => (
                                <Nav.Item as="li" key={i}>
                                  <Nav.Link eventKey={data.key}>
                                    {data.name}
                                  </Nav.Link>
                                </Nav.Item>
                              ))
                          : tabData.map((data, i) => (
                              <Nav.Item as="li" key={i}>
                                <Nav.Link eventKey={data.key}>
                                  {data.name}
                                </Nav.Link>
                              </Nav.Item>
                            ))}
                      </Nav>
                      <Tab.Content className="pt-4">
                        {activeKey === "all" && (
                          <Tab.Pane eventKey="all">
                            <AllPayouts />
                          </Tab.Pane>
                        )}
                        {activeKey === "pending" && (
                          <Tab.Pane eventKey="pending">
                            <Pending />
                          </Tab.Pane>
                        )}
                        {activeKey === "processed" && (
                          <Tab.Pane eventKey="processed">
                            <Processed />
                          </Tab.Pane>
                        )}
                        {activeKey === "paymentdetails" && (
                          <Tab.Pane eventKey="paymentdetails">
                            <PaymentDetails />
                          </Tab.Pane>
                        )}
                      </Tab.Content>
                    </Tab.Container>
                  </div>
                </Card.Body>
              </Tab.Content>
            </Card>
          </Tab.Container>
        </div>
      ) : (
        <></>
      )}
    </>
  );
};
export default constore(MyEarnings);
